export const BULK_CONTACT_SMS_TEXT_MAX = 1000;
export const BULK_CONTACT_SMS_TEXTS_MAX = 50;

export function parseBulkTexts(raw: string): string[] {
	return raw
		.split(/\n\n+/)
		.map(part => part.trim())
		.filter(part => part.length > 0);
}

export function validateBulkTexts(texts: string[]): string | null {
	if (texts.length === 0) return 'Укажите хотя бы один текст';
	if (texts.length > BULK_CONTACT_SMS_TEXTS_MAX) {
		return `Не больше ${BULK_CONTACT_SMS_TEXTS_MAX} вариантов`;
	}
	if (texts.some(text => text.length > BULK_CONTACT_SMS_TEXT_MAX)) {
		return `Текст не длиннее ${BULK_CONTACT_SMS_TEXT_MAX} символов`;
	}
	return null;
}
